export const globalpropsConstants = {

    CREATE_PROPS: 'CREATE_PROPS',
    DELETE_PROPS: 'DELETE_PROPS',
    EDIT_PROPS: 'EDIT_PROPS',
    SET_PROP_TYPES: 'SET_PROP_TYPES',
    SET_PROPS:'SET_PROPS',
    SET_RESET:"SET_RESET"
}